import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=04290b0b&scoped=true"
import script from "./detail.ts?vue&type=script&lang=js&external"
export * from "./detail.ts?vue&type=script&lang=js&external"
import style0 from "./detail.vue?vue&type=style&index=0&id=04290b0b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04290b0b",
  null
  
)

export default component.exports